import { Platform, StyleSheet } from 'react-native';
import Typography from '../../../../shared/constants/Typography';

export const createErrorToastStyles = (theme: any, successToast: boolean) =>
  StyleSheet.create({
    container: {
      position: Typography.position.absolute,
      top: Platform?.OS === 'web' ?  Typography.height.height14: Typography.height.height45,
      alignSelf: Typography.textAlign.centerAlign,
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      backgroundColor: successToast ? theme.successBgColor: theme.bgColor,
      paddingHorizontal: Typography.padding.padding16,
      paddingVertical: Typography.padding.padding12,
      borderRadius: Typography.radius.radius8,
      borderWidth: Typography.borderWidth.borderWidth1,
      borderColor: successToast ? theme.successBorder: theme.border,
      elevation: 5,
      zIndex: 9999,
      gap: Typography.gap.gap10,
    },
    childContainer: {
      top: Typography.height.height10,
    },
    text: {
      color: theme.text,
      fontSize: Typography.fontSize.fontSize16,
      fontFamily: Typography.fontFamily.inter,
      fontWeight: Typography.fontWeight.regular,
    },
    successText: {
      color: theme.successText,
      fontSize: Typography.fontSize.fontSize16,
      fontFamily: Typography.fontFamily.inter,
      fontWeight: Typography.fontWeight.regular,
    }
  });
